import React from 'react';
import {
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Link,
    Stack,
    Typography
} from '@mui/material';

const getSuhtautuminenMeta = (value) => {
    if (value === 1) {
        return { label: 'Myönteinen', color: '#2e7d32', backgroundColor: '#e8f5e9' };
    }

    if (value === 0) {
        return { label: 'Neutraali', color: '#ed6c02', backgroundColor: '#fff3e0' };
    }

    if (value === -1) {
        return { label: 'Kielteinen', color: '#d32f2f', backgroundColor: '#ffebee' };
    }

    return { label: 'Ei arviota', color: '#546e7a', backgroundColor: '#eceff1' };
};

const ReportsModal = ({ open, onClose, reports = [], yhteistyotaho, summary }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            scroll="paper"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    maxHeight: '88vh'
                }
            }}
        >
            <DialogTitle sx={{ pb: 1.5 }}>
                <Stack spacing={1}>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                        Raportit: {yhteistyotaho}
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <Chip
                            label={`${reports.length} raporttia`}
                            sx={{ fontWeight: 600, bgcolor: '#f3f6fb' }}
                        />
                        {summary?.averageMeta && (
                            <Chip
                                label={`Keskimääräinen suhtautuminen: ${summary.averageMeta.label}`}
                                sx={{
                                    fontWeight: 600,
                                    color: summary.averageMeta.color,
                                    bgcolor: summary.averageMeta.backgroundColor
                                }}
                            />
                        )}
                        {summary?.latestReportLabel && (
                            <Chip
                                label={`Viimeisin raportti: ${summary.latestReportLabel}`}
                                variant="outlined"
                            />
                        )}
                    </Stack>
                </Stack>
            </DialogTitle>
            <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, py: 2.5 }}>
                {reports.length === 0 ? (
                    <Typography color="text.secondary">
                        Yhteistyötaholle ei löytynyt raportteja.
                    </Typography>
                ) : (
                    <Stack spacing={2}>
                        {reports.map((report, index) => {
                            const suhtautuminenMeta = getSuhtautuminenMeta(report.suhtautuminen);

                            return (
                                <Box
                                    key={report.id || `${report.tapahtumaId}-${index}`}
                                    sx={{
                                        border: '1px solid #e0e0e0',
                                        borderRadius: 3,
                                        p: 2,
                                        bgcolor: '#fff'
                                    }}
                                >
                                    <Stack spacing={1.25}>
                                        <Stack
                                            direction={{ xs: 'column', sm: 'row' }}
                                            justifyContent="space-between"
                                            spacing={1}
                                        >
                                            <Box>
                                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                    {report.tapahtumaNimi}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    Tapahtuma ID: {report.tapahtumaId}
                                                </Typography>
                                            </Box>
                                            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                                <Chip
                                                    label={report.paivamaara}
                                                    size="small"
                                                    variant="outlined"
                                                />
                                                <Chip
                                                    label={suhtautuminenMeta.label}
                                                    size="small"
                                                    sx={{
                                                        color: suhtautuminenMeta.color,
                                                        bgcolor: suhtautuminenMeta.backgroundColor,
                                                        fontWeight: 600
                                                    }}
                                                />
                                            </Stack>
                                        </Stack>
                                        <Divider />
                                        <Stack spacing={0.5}>
                                            <Typography variant="body2">
                                                <strong>Paikka:</strong> {report.osoite}
                                                {report.kunta ? `, ${report.kunta}` : ''}
                                            </Typography>
                                            <Typography variant="body2">
                                                <strong>Väkimäärä:</strong> {report.vakimaara}
                                            </Typography>
                                            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                                                <strong>Muistiinpano:</strong> {report.muistiinpano}
                                            </Typography>
                                        </Stack>
                                        <Box>
                                            <Link href={`/tapahtumat/${report.tapahtumaId}`} target="_blank" rel="noopener">
                                                Avaa tapahtuma uuteen välilehteen
                                            </Link>
                                        </Box>
                                    </Stack>
                                </Box>
                            );
                        })}
                    </Stack>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} variant="contained">
                    Sulje
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReportsModal;
